// extracted by mini-css-extract-plugin
export default {"empty":"Report_empty__Z8LE5","placeHolderShimmer":"Report_placeHolderShimmer__V9ap5"};